import { render, staticRenderFns } from "./ShiftDetails.vue?vue&type=template&id=dfbaed08&"
import script from "./ShiftDetails.vue?vue&type=script&lang=js&"
export * from "./ShiftDetails.vue?vue&type=script&lang=js&"
import style0 from "./ShiftDetails.vue?vue&type=style&index=0&id=dfbaed08&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports